import withStyles from '@mui/styles/withStyles';
import { Paper } from '@mui/material';

export const PickerContainer = withStyles({
  root: {
    padding: 6,
  },
})(Paper);
